import SearchDropDown from "../../generic_components/SearchDropDown";
import { Row, Col, Spinner } from "react-bootstrap";
import { useProductCompanies } from "../../../api/simDocuments/ProductCompanyService";
import { ISelectProductCompanyProps } from "../FrontPageInterfaces";

export default function SelectProductCompany({
  onSelect,
  isDisabled,
  setIsDropdownOpen,
  isDropdownOpen,
}: ISelectProductCompanyProps) {
  const { productCompanies, loading: loadingProductCompanies } =
    useProductCompanies();

  return (
    <Row className="padding-top">
      <Col xs={4}>
        <label>Product Company</label>
      </Col>
      <Col xs={6}>
        {loadingProductCompanies ? (
          <Spinner animation="border" />
        ) : (
          <SearchDropDown
            showCode={true}
            setOpen={setIsDropdownOpen}
            close={isDropdownOpen}
            options={productCompanies}
            onSelect={(selectedKey, selectedLabel) =>
              onSelect(selectedKey, selectedLabel, true)
            }
            disabled={isDisabled}
          />
        )}
      </Col>
    </Row>
  );
}
